import {inject, Injectable} from "@angular/core";
import {ComputeSensitivitiesRequest, FundApiService, FundValuationSensitivity} from "../generated-sources/api";
import {Observable} from "rxjs";
import {FundValuationSensitivityOverview} from "../models/fund-valuation-sensitivity-overview";

@Injectable({
  providedIn: "root"
})
export class FundValuationSensitivityService {
    private readonly fundApiService = inject(FundApiService)

    public getSensitivityForFundValuation(fundId: number, fundValuationId: number): Observable<FundValuationSensitivityOverview> {
        return this.fundApiService.getSensitivityForFundValuation(fundId, fundValuationId);
    }

    public computeSensitivitiesForFundValuation(fundId: number, fundValuationId: number, request?: ComputeSensitivitiesRequest): Observable<FundValuationSensitivityOverview> {
        return this.fundApiService.computeSensitivitiesForFundValuation(fundId, fundValuationId, request);
    }

    public getSensitivityDetailsForFundValuation(fundId: number, fundValuationId: number, fundValuationSensitivityId: number): Observable<FundValuationSensitivity> {
        return this.fundApiService.getSensitivityDetailsForFundValuation(fundId, fundValuationId, fundValuationSensitivityId);
    }
}
